import { supabase } from './client';

export type SharedCartItem = {
  id: string;
  product_id: string;
  quantity: number;
  unit_price: number;
  title?: string | null;
  description?: string | null;
  main_image_url?: string | null;
  cover_url?: string | null;
  image_urls?: string[] | null;
  stock?: number | null;
  is_digital?: boolean | null;
  product_type?: string | null;
  fixed_sale_price?: number | null;
  store_id?: string | null;
};

export type CartAccess = {
  user_id: string;
  username: string | null;
  display_name: string | null;
  avatar_url: string | null;
  access_type: 'owner' | 'store_member' | 'admin' | 'shared_with';
};

export type SharedCart = {
  id: string;
  store_id: string;
  user_id: string;
  status: string;
  created_at: string;
  updated_at: string;
  owner_username: string;
  store_name: string;
  store_slug: string | null;
  shared_by_user_id?: string | null;
  items: SharedCartItem[];
};

export const shareCartWithUsers = async (cartId: string, userIds: string[]): Promise<number> => {
  const cleanIds = Array.from(new Set((userIds || []).filter(Boolean)));
  if (cleanIds.length === 0) return 0;

  const { data, error } = await supabase.rpc('share_cart_with_users', {
    p_cart_id: cartId,
    p_user_ids: cleanIds,
  });

  if (error) throw error;
  return Number.isFinite(Number(data)) ? Number(data) : 0;
};

export const getCartsSharedWithMe = async (): Promise<SharedCart[]> => {
  const { data, error } = await supabase.rpc('get_carts_shared_with_me');

  if (error) {
    console.error('[sharedCarts] get_carts_shared_with_me RPC error:', error);
    return [];
  }
  if (!Array.isArray(data)) {
    console.warn('[sharedCarts] get_carts_shared_with_me returned non-array:', data);
    return [];
  }
  return data as SharedCart[];
};

export const getCartAccessList = async (cartId: string): Promise<CartAccess[]> => {
  const { data, error } = await supabase.rpc('get_cart_access_list', {
    p_cart_id: cartId,
  });

  if (error) throw error;
  if (!Array.isArray(data)) return [];
  return data as CartAccess[];
};

export const removeCartAccess = async (cartId: string, userId: string): Promise<void> => {
  const { error } = await supabase.rpc('remove_cart_access', {
    p_cart_id: cartId,
    p_user_id: userId,
  });

  if (error) throw error;
};
